"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var subjectAreaMap_1 = require("../subjects_data/subjectAreaMap");
var courseIsSubjectArea_1 = require("../utils/courseIsSubjectArea");
var electives_1 = require("./electives");
var math_1 = require("./math");
var science_1 = require("./science");
var pe_1 = require("./pe");
var english_1 = require("./english");
var socialStudies_1 = require("./socialStudies");
var languageOTE_1 = require("./languageOTE");
var fineArts_1 = require("./fineArts");
var requireCoursesFromMap_1 = require("../utils/requireCoursesFromMap");
var combineVerifications_1 = require("../utils/combineVerifications");
var courseOptionsFromCourseMap_1 = require("../utils/courseOptionsFromCourseMap");
var mustPassOneOfValidations_1 = require("../utils/mustPassOneOfValidations");
var uniqueLanguages_1 = require("../uniqueLanguages");
exports.default = function (courses, courseMap) {
    var foreignLanguageCourses = courses.filter(courseIsSubjectArea_1.default(subjectAreaMap_1.subjectAreasMap.foreignLanguage));
    var foreignLanguageCoursesMap = foreignLanguageCourses.reduce(function (map, c) {
        map[c.course_title.toLowerCase()] = c;
        return map;
    }, {});
    var foreignLanguageCourseReqMap = foreignLanguageCourses.reduce(function (map, c) {
        map[c.course_title.toLowerCase()] = 1;
        return map;
    }, {});
    var options = {
        englishBaseOptions: courseOptionsFromCourseMap_1.default(courseMap, english_1.default.baseRequirements, 3, 'english-base-options'),
        englishExtraOptions: courseOptionsFromCourseMap_1.default(courseMap, english_1.default.oneAdditionalCredit, 1, 'english-extra-options'),
        mathBaseOptions: courseOptionsFromCourseMap_1.default(courseMap, math_1.default.baseRequirements, 2, 'math-base-options'),
        mathExtraOptions: courseOptionsFromCourseMap_1.default(courseMap, math_1.default.oneAdditionalCredit, 1, 'math-extra-options'),
        scienceBaseOptions: courseOptionsFromCourseMap_1.default(courseMap, science_1.default.baseRequirements, 1, 'science-base-options'),
        scienceExtraAOptions: courseOptionsFromCourseMap_1.default(courseMap, science_1.default.oneAdditionalCredit, 1, 'science-additional-A-options'),
        scienceExtraBOptions: courseOptionsFromCourseMap_1.default(courseMap, science_1.default.oneAdditionalCreditB, 1, 'science-additional-B-options'),
        socialStudiesBaseOptions: courseOptionsFromCourseMap_1.default(courseMap, socialStudies_1.default.baseRequirements, 2, 'social-studies-base-options'),
        socialStudiesExtraOptions: courseOptionsFromCourseMap_1.default(courseMap, socialStudies_1.default.oneAdditionalCredit, 1, 'social-studies-extra-options'),
        loteAOptions: courseOptionsFromCourseMap_1.default(courseMap, languageOTE_1.default.option2.requiredCourses, 2, 'lote-options-A'),
        loteBOptions: courseOptionsFromCourseMap_1.default(foreignLanguageCoursesMap, foreignLanguageCourseReqMap, 2, 'lote-option-b', true),
        peOptions: courseOptionsFromCourseMap_1.default(courseMap, pe_1.default.requiredCourses, 1, 'pe-options'),
        electiveOptions: courseOptionsFromCourseMap_1.default(courseMap, __assign({}, electives_1.default.sevenCreditsFrom, foreignLanguageCourseReqMap), 7, 'elective-options'),
        fineArtsOptions: courseOptionsFromCourseMap_1.default(courseMap, fineArts_1.default.oneOf, 1, 'fine-arts-options')
    };
    var validations = {
        options: options,
        // english
        englishRequirements: english_1.default,
        validateEnglishBaseRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, english_1.default.baseRequirements, 'courses-required-by-english', 3),
        validateEnglishExtraRequirement: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, english_1.default.oneAdditionalCredit, 'additional-credit-for-english', 1),
        // math
        validateMathBaseRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, math_1.default.baseRequirements, 'courses-required-by-math', 2),
        validateMathExtraRequirement: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, math_1.default.oneAdditionalCredit, 'additional-credit-for-math', 1),
        mathRequirements: math_1.default,
        // science
        validateScienceBaseRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, science_1.default.baseRequirements, 'courses-required-by-science', 1),
        validateScienceExtraRequirementA: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, science_1.default.oneAdditionalCredit, 'first-additional-credit-for-science', 1),
        validateScienceExtraRequirementB: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, science_1.default.oneAdditionalCreditB, 'second-additional-credit-for-science', 1),
        scienceRequirements: science_1.default,
        // social studies
        validateSocialStudiesBaseRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, socialStudies_1.default.baseRequirements, 'courses-required-by-social-studies', 2),
        validateSocialStudiesExtraRequirement: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, socialStudies_1.default.oneAdditionalCredit, 'additional-credit-for-social-studies', 1),
        socialStudiesRequirements: socialStudies_1.default,
        // lote
        validateLOTEBaseRequirements: mustPassOneOfValidations_1.mustPassOneOf.apply(void 0, [courses,
            requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, languageOTE_1.default.option2.requiredCourses, 'courses-required-by-lote-comp-sci', 2)].concat(uniqueLanguages_1.uniqueLanguages.map(function (l) {
            var coursesThatMatchThisLang = foreignLanguageCourses
                .filter(function (c) {
                return c.course_title.toLowerCase().match(l
                    .slice(0, 4)
                    .trim()
                    .toLowerCase());
            })
                .reduce(function (map, c) {
                map[c.course_title.toLowerCase()] = 1;
                return map;
            }, {});
            return requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, coursesThatMatchThisLang, 'courses-required-by-lote-' + l, 2);
        }))),
        languageOTERequirements: languageOTE_1.default,
        // PE
        validatePhysicalEducationRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, pe_1.default.requiredCourses, 'pe-requirements', 1),
        physicalEducationRequirements: pe_1.default,
        // elective requirements
        validateElectiveRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, __assign({}, electives_1.default.sevenCreditsFrom, foreignLanguageCourseReqMap), 'elective-requirements', 7),
        electivesRequirements: electives_1.default,
        // fine arts requirements'
        validateFineArtsRequirements: requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, fineArts_1.default.oneOf, 'fine-arts-requirements', 1),
        fineArtsRequirements: fineArts_1.default,
        // this is outdated, but still here for reference
        /**
         * @returns VerificationResult
         */
        validate: function (localCourses) {
            if (localCourses === void 0) { localCourses = courses; }
            var englishResult = validations.validateEnglishBaseRequirements(localCourses);
            var extraEnglishResult = validations.validateEnglishExtraRequirement(englishResult.coursesNotConsumed);
            var mathBaseResult = validations.validateMathBaseRequirements(extraEnglishResult.coursesNotConsumed);
            var mathExtraResult = validations.validateMathExtraRequirement(mathBaseResult.coursesNotConsumed);
            var scienceBaseResult = validations.validateScienceBaseRequirements(mathExtraResult.coursesNotConsumed);
            var scienceExtraResultA = validations.validateScienceExtraRequirementA(scienceBaseResult.coursesNotConsumed);
            var scienceExtraResultB = validations.validateScienceExtraRequirementB(scienceExtraResultA.coursesNotConsumed);
            var socialStudiesBaseResults = validations.validateSocialStudiesBaseRequirements(scienceExtraResultB.coursesNotConsumed);
            var socialStudiesExtraResults = validations.validateSocialStudiesExtraRequirement(socialStudiesBaseResults.coursesNotConsumed);
            var peResults = validations.validatePhysicalEducationRequirements(socialStudiesExtraResults.coursesNotConsumed);
            var loteBaseResults = validations.validateLOTEBaseRequirements(socialStudiesExtraResults.coursesNotConsumed);
            var electiveResults = validations.validateElectiveRequirements(socialStudiesExtraResults.coursesNotConsumed);
            var fineArtsResults = validations.validateFineArtsRequirements(socialStudiesExtraResults.coursesNotConsumed);
            var subVerificationResults = [
                englishResult,
                extraEnglishResult,
                mathBaseResult,
                mathExtraResult,
                scienceBaseResult,
                scienceExtraResultA,
                scienceExtraResultB,
                socialStudiesBaseResults,
                socialStudiesExtraResults,
                loteBaseResults,
                peResults,
                electiveResults,
                fineArtsResults
            ];
            return combineVerifications_1.default(subVerificationResults, fineArtsResults.coursesNotConsumed);
        }
    };
    return validations;
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/index.js
// module id = 445
// module chunks = 22